import { Component, Input } from '@angular/core';

import { Observable } from 'rxjs';

import { ButtonTypesEnum } from '../../../Forms/enums/button-types.enum';
import { CoreDialogService } from '../../../../Core/Dialogs/services/dialog.service';
import { AbstractDialogComponent } from '../../../../Core/Dialogs/components/AbstractDialog/abstract-dialog.component';
import { FullProfileAnimationModel } from '../../../../Core/Dialogs/models/full-profile-animation.model';

@Component({
    selector: 'agpr-preview-text-dialog',
    templateUrl: './preview-text-dialog.component.html',
    styleUrls: ['./preview-text-dialog.component.scss'],
    standalone: false
})
export class PreviewTextDialogComponent extends AbstractDialogComponent {

    @Input() heading: string = 'Common.dialog.previewText';
    @Input() content: string;
    @Input() overlayContainer: Element;
    @Input() animationTrigger: Observable<FullProfileAnimationModel>;

    readonly id = 'previewTextDialog';
    readonly buttonType = ButtonTypesEnum;

    constructor(coreDialogService: CoreDialogService,) {
        super(coreDialogService, 'PreviewTextDialog');
    }

    close() {
        this.closeDialog();
    }
}
